/**
 * Librerías de haciendola
 * Esta es la clase principal que centraliza las distintas librerías de Haciendola
 * Uso: Haciendola.registerLibrary("nombre_de_la_libreria",instancia) // El 2do parámetro es la instancia de una clase, esta justamente es la librería en cuestión
 *
 * Haciendola.nombre_de_la_librería.usarMetodo() // Será la forma de acceso y uso de la librería en cuestión.
 */

window.Haciendola = new (class {
  constructor() {
    console.log("=== Haciendola Dawn ===")
  }

  registerLibrary(name, library) {
    this[name] = library
  }
})()

if (window.location.href.indexOf('checkouts') > -1) {
    window.onload = function() {

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBOImo3FX6ErzcnZJPnMAw4yA-33Zk2sqM&libraries=places";
        script.async = "true";
        script.defer = "defer";
        document.body.appendChild(script);

        setTimeout(initAutocomplete, 2000);

        var lookup = {
            "street_number": document.getElementById('TextField2'),
            "route": document.getElementById('TextField2'),
            "fullAddress": document.getElementById('TextField2'),
            "locality": document.getElementById('TextField4'),
            "neighborhood": document.getElementById('TextField4'),
            "administrative_area_level_1": document.getElementById('Select1'),
            "country": document.getElementById('Select0'),
            "postal_code": document.getElementById('TextField3')
        };
        var placeSearch;
        var autocomplete;
        var componentForm = {
            street_number: 'short_name',
            route: 'long_name',
            locality: 'long_name',
            administrative_area_level_1: 'long_name',
            country: 'long_name',
            neighborhood: 'long_name',
            postal_code: 'short_name'
        };

        function initAutocomplete() {
            document.getElementById('TextField2').onFocus = "geolocate()";

            autocomplete = new google.maps.places.Autocomplete(
                (document.getElementById('TextField2')), { types: ['geocode'] });

            autocomplete.addListener('place_changed', fillInAddress);
        }


        function fillInAddress() {
            var place = autocomplete.getPlace();
            for (var component in componentForm) {
                lookup[component].value = '';
            }
            var fullAddress = '';
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                var val = place.address_components[i][componentForm[addressType]];
                if (componentForm[addressType]) {
                    switch (addressType) {
                        case 'street_number':
                            fullAddress = val + fullAddress;
                            break;
                        case 'route':
                            fullAddress = fullAddress + ' ';
                            fullAddress = fullAddress + val;
                            break;
                        case 'neighborhood':
                            lookup.neighborhood.value = val;
                            break;
                        case 'locality':
                            lookup.locality.value = val;
                            break;
                        case 'administrative_area_level_1':
                            lookup.administrative_area_level_1.value = val;
                            break;
                        case 'country':
                            lookup.country.value = val;
                            break;
                        case 'postal_code':
                            lookup.postal_code.value = val;
                            break;
                    }
                }
            }
            lookup.fullAddress.value = fullAddress;
        }

        function geolocate() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position) {
                    var geolocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    var circle = new google.maps.Circle({
                        center: geolocation,
                        radius: position.coords.accuracy
                    });
                    autocomplete.setBounds(circle.getBounds());
                });
            }
        }


    };
}